import { render, staticRenderFns } from "./SelectBucketingModal.vue?vue&type=template&id=2d4ce83a&scoped=true"
import script from "./SelectBucketingModal.vue?vue&type=script&lang=ts"
export * from "./SelectBucketingModal.vue?vue&type=script&lang=ts"
import style0 from "./SelectBucketingModal.vue?vue&type=style&index=0&id=2d4ce83a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ce83a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4ce83a')) {
      api.createRecord('2d4ce83a', component.options)
    } else {
      api.reload('2d4ce83a', component.options)
    }
    module.hot.accept("./SelectBucketingModal.vue?vue&type=template&id=2d4ce83a&scoped=true", function () {
      api.rerender('2d4ce83a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/SelectBucketingModal.vue"
export default component.exports